/*
 * @Author: libo 
 * @Date: 2020-11-19 10:58:20 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-02-25 19:29:54
 */

<template>
    <a-modal
        :width="modalWidth"
        :visible="visible"
        :title="title"
        destroyOnClose
        :confirmLoading="confirmLoading"
        @ok="handleSubmit"
        @cancel="handleCancel"
                :cancelText="$t('关闭')"
        wrapClassName="ant-modal-cust-warp"
        >
        <template>
          <a-card style="" :bordered="true" :title="$t('数据详情')">
            <detail-list>
              <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
              <detail-list-item :term="$t('用户编号')">{{model.userId}}</detail-list-item>
              <detail-list-item :term="$t('用户姓名')">{{model.userPhone}}</detail-list-item>
              <detail-list-item :term="$t('表类型')">{{model.userPhone}}</detail-list-item>
              <detail-list-item :term="$t('阀门状态')">{{model.userPhone}}</detail-list-item>
              <detail-list-item :term="$t('安装地址')">{{model.userPhone}}</detail-list-item>
              <detail-list-item :term="$t('故障')">{{model.userPhone}}</detail-list-item>
              <detail-list-item :term="$t('用水地址')">{{model.userMeterAddr}}</detail-list-item>
            </detail-list>
          </a-card>
          <a-form-model ref="formModel" :model="formModel" :rules="rules" :colon="false">
            <a-row :gutter="16">
              <a-col :span="24">
                <a-form-item :label="$t('处理描述')">
                  <a-textarea v-model="formModel.remark" :placeholder="$t('请输入处理描述')" :rows="3" style="width:100%;"/>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="7">
              </a-col>
              <a-col :span="8">
                <h4 style="font-weight: bold;">{{ $t('请选择处理状态') }}:</h4>
                <a-select v-model="formModel.meterDealStatus" :placeholder="$t('请选择处理状态')" type="primary">
                  <a-select-option :value="0">
                    {{ $t('未处理') }}
                  </a-select-option>
                  <a-select-option :value="1">
                    {{ $t('处理中') }}
                  </a-select-option>
                  <a-select-option :value="2">
                    {{ $t('已处理') }}
                  </a-select-option>
                </a-select>
              </a-col>
            </a-row>
          </a-form-model>
        </template>
    </a-modal>
</template>
<script>
  import { httpAction, getAction,putAction } from '@/api/manage'
  import { postAction } from '@/api/manage'
  import {isNull} from '@/utils/validate'
  import moment from 'moment'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  export default {
    name: 'MeterReadingAbnormalModal',
    components: {
      DetailList,
      DetailListItem
    },
    data () {
      return {
        title:'',
        modalWidth:900,
        visible: false,
        confirmLoading: false,
        model: {},
        formModel: {},
        rules:{
        },
        value: 1,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 14 },
        },
        form: this.$form.createForm(this),
        url: {
          add: "/jeecg-charge/meter/meterUserinfo/add",
          edit: "/jeecg-charge/meter/meterUserinfo/edit",
          queryById: "/jeecg-charge/meter/meterUserinfo/queryById",
          doPayTask:"/jeecg-charge/meter/userPay/doPayTask",  //提交
        },
      }
    },
    computed:{
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
    },
    methods: {
      edit(record) {
        this.visible = true;
        this.model = Object.assign({}, record);
        console.log(this.model);
        this.formModel.meterId = record.meterId
      },
      handleSubmit () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.doPayTask;
              method = 'put';
            }else{
              httpurl+=this.url.doPayTask;
              method = 'put';
            }
            let params = Object.assign({},this.formModel)
            params.userKeyId = this.model.id
            params.userId = this.model.userId
            params.meterId = this.model.meterId
            console.log("处理提交数据",params)
            httpAction(httpurl,params,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              // this.loadData();
            })
            this.handleCancel();
          }
        })
      },
      handleCancel() {
        this.close();
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
    }
  }
</script>
<style scoped>
.ant-row{
  margin-top: 8px;
}
.ant-form-item{
  margin-bottom: 8px;
}
.detail-list >>> .content{
  line-height: normal;
}
</style>